<template>
    <div class="topMenu text-right">
        <template v-if="!logedin">
            <a href="/register">Registrieren</a>
            <div class="separator">|</div>
            <a href="/login" class="login">Anmelden</a>
        </template>
        <template v-else>
            <a href="#" @click="logout" class="login">Ausloggen</a>
        </template>
    </div>
</template>

<script>
    export default {
        props: {
            user: {
                type: [Boolean],
                required: true,
                default: false
            }
        },

        data () { 
            return {
                logedin: false
            }
        },

        created() {
            this.logedin = this.user;
            App.event.listen('login.success', (response) => {
                this.logedin = true;
            });
        },

        methods: {
            logout() {
                new Form({_token: window.axios.defaults.headers.common['X-CSRF-TOKEN']}).post('/logout').then(() => {
                    location.reload();
                });
            }
        }
    }
</script>
